import Typography from "@vapor/react-extended/ExtendedTypography";
import Grid from "@vapor/react-material/Grid";
import Box from "@vapor/react-material/Box";
import { StatSection } from "./StatComponents";

const ClientiStatsTab = ({ isLoading, displayStats, riskColors, generalColors }) => {
    return (
        <>
            {isLoading && 
                <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
                    <Typography>Caricamento dati statistici...</Typography>
                </Box>
            }
            {!isLoading && 
            <>
                <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>                    
                        <StatSection
                            title="Zone Geografiche"
                            stats={displayStats?.zoneGeografiche}
                            colors={riskColors}
                        />  
                    </Grid>
                    
                    <Grid item xs={12} md={6}>
                        <StatSection
                            title="Persone Politicamente Esposte (PPE)"
                            stats={displayStats?.ppe}
                            colors={generalColors}
                        />                                                                                                             
                    </Grid>                    
                    
                    <Grid item xs={12} md={6}>                                                                                                                               
                        <StatSection
                            title="Rischio Specifico Cliente"
                            stats={displayStats?.rischioSpecifico}
                            colors={riskColors}
                        />                                                
                    </Grid>
                </Grid>
                
            
                <Typography variant="h5" sx={{ mt: 4, mb: 3, textAlign: 'center', color: '#000000ff', fontSize: '1.25rem' }}>
                    Punteggi delle Valutazioni
                </Typography>
                
                <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                        <StatSection
                            title="A1 - Natura Giuridica"
                            stats={displayStats?.naturaGiuridicaPunteggio}
                            colors={riskColors}
                        />
                    </Grid>

                    <Grid item xs={12} md={6}>    
                        <StatSection
                            title="A3 - Comportamento Cliente"
                            stats={displayStats?.comportamentoPunteggio}
                            colors={riskColors}
                        />                    
                    </Grid>                               
                    
                    <Grid item xs={12} md={6}>
                        <StatSection
                            title="A2 - Attività Svolta"
                            stats={displayStats?.attivitaSvoltaPunteggio}
                            colors={riskColors}
                        />
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <StatSection
                            title="A4 - Area Geografica Residenza"
                            stats={displayStats?.areaGeograficaPunteggio}
                            colors={riskColors}
                        />
                    </Grid>
                </Grid>
            </>}
        </>
    );
};

export default ClientiStatsTab;